import {IClassificationResource} from "../../core/services/ClassificationService"
import * as _ from "lodash";
import * as swal from "sweetalert";
export class ClassificationManagementPageComponent implements ng.IComponentOptions {
  public controller: any = ClassificationManagementController;
  public template: string =
    `<h2>Classification Management <span class="subtitle">- {{$ctrl.title[$ctrl.type]}}</span>
      <button ng-show="$ctrl.type === 'group'" class="btn btn-primary pull-right" ng-click="$ctrl.addGroup()">ADD NEW</button>
      <button ng-show="$ctrl.type === 'category'" class="btn btn-primary pull-right" ng-click="$ctrl.addCategory()">ADD NEW</button>
      <button ng-show="$ctrl.type === 'user_type'" class="btn btn-primary pull-right" ng-click="$ctrl.addUserType()">ADD NEW</button>
      <button ng-show="$ctrl.type === 'organisation_type'" class="btn btn-primary pull-right" ng-click="$ctrl.addOrgType()">ADD NEW</button>
      <button ng-show="$ctrl.type === 'feedback_type'" class="btn btn-primary pull-right" ng-click="$ctrl.addFeedbackType()">ADD NEW</button>
      <button ng-show="$ctrl.type === 'purpose'" class="btn btn-primary pull-right" ng-click="$ctrl.addPurpose()">ADD NEW</button>
    </h2>
      <div ng-show="$ctrl.type === 'group'">
      <div class="row padding-top">
        <div class="col-md-9">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search" ng-model="searchText.group"/>
            <span class="input-group-btn">
              <button class="btn btn-default">
                <i class="fa fa-fw fa-search"></i>
              </button>
            </span>
          </div>
        </div>
        <div class="col-md-3">
        </div>
      </div>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th><input type="checkbox" ng-model="$ctrl.selectedAll.group" ng-click="$ctrl.selectAllGroup()"/></th>
            <th>Group Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('group','name')"></i></th>
            <th>Code<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('group','code')"></i></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="group in $ctrl.groups | filter: searchText.group | orderBy: $ctrl.sortType.group: $ctrl.reverse.group">
            <td><input type="checkbox" ng-model="group.selected" /></td>
            <td>{{group.name}}</td>
            <td>{{group.code}}</td>
            <td><i class="fa fa-fw fa-pencil btn-icon" uib-tooltip="Edit Group" ng-click="$ctrl.editClassification('group', group)"></i></td>
          </tr>
        </tbody>
      </table>
      <div class="row padding-bottom">
        <div class="col-md-12">
          <button class="btn btn-default" ng-click="$ctrl.del('group')">DELETE</button>
        </div>
      </div>
      </div>
      <div ng-show="$ctrl.type === 'category'">
      <div class="row padding-top">
        <div class="col-md-9">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search" ng-model="searchText.category"/>
            <span class="input-group-btn">
              <button class="btn btn-default">
                <i class="fa fa-fw fa-search"></i>
              </button>
            </span>
          </div>
        </div>
        <div class="col-md-3">
        </div>
      </div>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th><input type="checkbox" ng-model="$ctrl.selectedAll.category" ng-click="$ctrl.selectAllCategory()"/></th>
            <th>Category Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('category','name')"></i></th>
            <th>Code<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('category','code')"></i></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="category in $ctrl.categories | filter: searchText.category | orderBy: $ctrl.sortType.category: $ctrl.reverse.category">
            <td><input type="checkbox" ng-model="category.selected" /></td>
            <td>{{category.name}}</td>
            <td>{{category.code}}</td>
            <td><i class="fa fa-fw fa-pencil btn-icon" uib-tooltip="Edit Category" ng-click="$ctrl.editClassification('category', category)"></i></td>
          </tr>
        </tbody>
      </table>
      <div class="row padding-bottom">
        <div class="col-md-12">
          <button class="btn btn-default" ng-click="$ctrl.del('category')">DELETE</button>
        </div>
      </div>
      </div>
      <div ng-show="$ctrl.type === 'user_type'">
      <div class="row padding-top">
        <div class="col-md-9">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search" ng-model="searchText.usertype.$"/>
            <span class="input-group-btn">
              <button class="btn btn-default">
                <i class="fa fa-fw fa-search"></i>
              </button>
            </span>
          </div>
        </div>
        <div class="col-md-3">
        </div>
      </div>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th><input type="checkbox" ng-model="$ctrl.selectedAll.usertype" ng-click="$ctrl.selectAllUserType()"/></th>
            <th>User Type Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('usertype','name')"></i></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="usertype in $ctrl.usertypes | filter: searchText.usertype | orderBy: $ctrl.sortType.usertype: $ctrl.reverse.usertype">
            <td><input type="checkbox" ng-model="usertype.selected" /></td>
            <td>{{usertype.name}}</td>
            <td><i class="fa fa-fw fa-pencil btn-icon" uib-tooltip="Edit User Type" ng-click="$ctrl.editClassification('usertype', usertype)"></i></td>
          </tr>
        </tbody>
      </table>
      <div class="row padding-bottom">
        <div class="col-md-12">
          <button class="btn btn-default" ng-click="$ctrl.del('usertype')">DELETE</button>
        </div>
      </div>
      </div>
      <div ng-show="$ctrl.type === 'organisation_type'">
      <div class="row padding-top">
        <div class="col-md-9">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search" ng-model="searchText.orgtype"/>
            <span class="input-group-btn">
              <button class="btn btn-default">
                <i class="fa fa-fw fa-search"></i>
              </button>
            </span>
          </div>
        </div>
        <div class="col-md-3">
        </div>
      </div>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th><input type="checkbox" ng-model="$ctrl.selectedAll.orgtype" ng-click="$ctrl.selectAllOrgType()"/></th>
            <th>Organisation Type Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('orgtype','name')"></i></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="orgtype in $ctrl.orgtypes | filter: searchText.orgtype | orderBy: $ctrl.sortType.orgtype: $ctrl.reverse.orgtype">
            <td><input type="checkbox" ng-model="orgtype.selected" /></td>
            <td>{{orgtype.name}}</td>
            <td><i class="fa fa-fw fa-pencil btn-icon" uib-tooltip="Edit Organisation Type" ng-click="$ctrl.editClassification('orgtype', orgtype)"></i></td>
          </tr>
        </tbody>
      </table>
      <div class="row padding-bottom">
        <div class="col-md-12">
          <button class="btn btn-default" ng-click="$ctrl.del('orgtype')">DELETE</button>
        </div>
      </div>
      </div>
      <div ng-show="$ctrl.type === 'feedback_type'">
      <div class="row padding-top">
        <div class="col-md-9">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search" ng-model="searchText.feedback_type"/>
            <span class="input-group-btn">
              <button class="btn btn-default">
                <i class="fa fa-fw fa-search"></i>
              </button>
            </span>
          </div>
        </div>
        <div class="col-md-3">
        </div>
      </div>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th><input type="checkbox" ng-model="$ctrl.selectedAll.feedback_type" ng-click="$ctrl.selectAllFeedbackType()"/></th>
            <th>Feedback Type Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('feedback_type','name')"></i></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="feedback in $ctrl.feedbacktypes | filter: searchText.feedback_type | orderBy: $ctrl.sortType.feedback_type: $ctrl.reverse.feedback_type">
            <td><input type="checkbox" ng-model="feedback_type.selected" /></td>
            <td>{{feedback.name}}</td>
            <td><i class="fa fa-fw fa-pencil btn-icon" uib-tooltip="Edit Feedback Type" ng-click="$ctrl.editClassification('feedback', feedback)"></i></td>
          </tr>
        </tbody>
      </table>
      <div class="row padding-bottom">
        <div class="col-md-12">
          <button class="btn btn-default" ng-click="$ctrl.del('feedbacktype')">DELETE</button>
        </div>
      </div>
      </div>
      <div ng-show="$ctrl.type === 'purpose'">
      <div class="row padding-top">
        <div class="col-md-9">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search" ng-model="searchText.purpose"/>
            <span class="input-group-btn">
              <button class="btn btn-default">
                <i class="fa fa-fw fa-search"></i>
              </button>
            </span>
          </div>
        </div>
        <div class="col-md-3">
        </div>
      </div>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th><input type="checkbox" ng-model="$ctrl.selectedAll.purpose" ng-click="$ctrl.selectAllPurpose()"/></th>
            <th>Purpose Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('purpose','name')"></i></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="purpose in $ctrl.purposes | filter: searchText.purpose | orderBy: $ctrl.sortType.purpose: $ctrl.reverse.purpose">
            <td><input type="checkbox" ng-model="purpose.selected" /></td>
            <td>{{purpose.name}}</td>
            <td><i class="fa fa-fw fa-pencil btn-icon" uib-tooltip="Edit Purpose" ng-click="$ctrl.editClassification('purpose', purpose)"></i></td>
          </tr>
        </tbody>
      </table>
      <div class="row padding-bottom">
        <div class="col-md-12">
          <button class="btn btn-default" ng-click="$ctrl.del('purpose')">DELETE</button>
        </div>
      </div>
      </div>
    `;
}

export class ClassificationManagementController {
  public static $inject: Array<string> = ["ClassificationService", "$uibModal", "$scope", "$stateParams"];
  public categories: Array<any>;
  public usertypes: Array<any>;
  public orgtypes: Array<any>;
  public feedbacktypes: Array<any>;
  public purposes: Array<any>;
  public groups: Array<any>;
  public sortType: any;
  public reverse: any;
  public selectedAll: any;
  public type: string;
  public title: any;
  constructor (private ClassificationService: IClassificationResource, private $uibModal: ng.ui.bootstrap.IModalService, private $scope: ng.IScope, private $stateParams: ng.ui.IStateParamsService) {
    $scope.$emit("adminPageChange",{name:"cat"});
    this.loadClassification();
    this.type = $stateParams.type || 'group';
    this.title = {
      'group': "Group",
      'category': "Category",
      'user_type': "User Type",
      'organisation_type': "Organisation Type",
      'feedback_type': "Feedback Type",
      'purpose': "Application Purpose"
    }
  }
  private loadClassification () {
    let _classifications = this.ClassificationService.query({state:"active"});
    _classifications.$promise.then(() => {
      this.categories = _.filter(_classifications, {type: "category"});
      this.usertypes = _.filter(_classifications, {type: "usertype"});
      this.orgtypes = _.filter(_classifications, {type: "orgtype"});
      this.feedbacktypes = _.filter(_classifications, {type: "feedbacktype"});
      this.purposes = _.filter(_classifications, {type: "purpose"});
      this.groups = _.filter(_classifications, {type: "group"});
    })
    this.sortType = {category: "name", usertype: "name", orgtype: "name", feedbacktype: "name", purpose: "name"};
    this.reverse = {category: false, usertype: false, orgtype: false, feedbacktype: false, purpose: false};
  }
  public addGroup () {
    let _modalInstance = this.$uibModal.open({
      component: 'classificationModal',
      resolve: {
        title: () => {return "Add Group";},
        type: () => {return "group"}
      }
    })
    _modalInstance.result.then((group) => {
      this.groups.unshift(group);
    })
  }
  public addCategory () {
    let _modalInstance = this.$uibModal.open({
      component: 'classificationModal',
      resolve: {
        title: () => {return "Add Category";},
        type: () => {return "category"}
      }
    })
    _modalInstance.result.then((category) => {
      this.categories.unshift(category);
    })
  }
  public addUserType () {
    let _modalInstance = this.$uibModal.open({
      component: 'classificationModal',
      resolve: {
        title: () => {return "Add User Type";},
        type: () => {return "usertype"}
      }
    })
    _modalInstance.result.then((usertype) => {
      this.usertypes.unshift(usertype);
    })
  }
  public addOrgType () {
    let _modalInstance = this.$uibModal.open({
      component: 'classificationModal',
      resolve: {
        title: () => {return "Add Organisation Type";},
        type: () => {return "orgtype"}
      }
    })
    _modalInstance.result.then((orgtype) => {
      this.orgtypes.unshift(orgtype);
    })
  }
  public addFeedbackType () {
    let _modalInstance = this.$uibModal.open({
      component: 'classificationModal',
      resolve: {
        title: () => {return "Add Feedback Type";},
        type: () => {return "feedbacktype"}
      }
    })
    _modalInstance.result.then((feedbacktype) => {
      this.feedbacktypes.unshift(feedbacktype);
    })
  }
  public addPurpose () {
    let _modalInstance = this.$uibModal.open({
      component: 'classificationModal',
      resolve: {
        title: () => {return "Add Purpose";},
        type: () => {return "purpose"}
      }
    })
    _modalInstance.result.then((purpose) => {
      this.purposes.unshift(purpose);
    })
  }
  public editClassification(type, classification) {
    let title = {
      'group': 'Edit Group',
      'category': 'Edit Category',
      'usertype': 'Edit User Type',
      'orgtype': 'Edit Organisation Type',
      'feedback': 'Edit Feedback Type',
      'purpose': 'Edit Purpose'
    };
    let _modalInstance = this.$uibModal.open({
      component: 'classificationModal',
      resolve: {
        title: () => {return title[type];},
        type: () => {return type},
        classification: () => {return classification}
      }
    })
    _modalInstance.result.then((_classification) => {
      this.loadClassification();
    })
  }
  public sortBy(classtype:string, type: string) {
    this.sortType[classtype] = type;
    this.reverse[classtype] = !this.reverse[classtype];
  }
  public selectAllCategory() {
    _.each(this.categories, (_category) => {
      _category.selected = this.selectedAll.category;
    })
  }
  public selectAllGroup() {
    _.each(this.groups, (_group) => {
      _group.selected = this.selectedAll.group;
    })
  }
  public selectAllUserType() {
    _.each(this.usertypes, (_usertype) => {
      _usertype.selected = this.selectedAll.usertype;
    })
  }
  public selectAllOrgType() {
    _.each(this.orgtypes, (_orgtype) => {
      _orgtype.selected = this.selectedAll.orgtype;
    })
  }
  public selectAllFeedbackType() {
    _.each(this.feedbacktypes, (_feedbacktype) => {
      _feedbacktype.selected = this.selectedAll.feedbacktype;
    })
  }
  public selectAllPurpose() {
    _.each(this.purposes, (_purpose) => {
      _purpose.selected = this.selectedAll.purpose;
    })
  }
  public del(type: string) {
    let _source;
    if (type == 'category')
      _source = this.categories;
    else if (type == 'group')
      _source = this.groups;
    else if (type == 'usertype')
      _source = this.usertypes;
    else if (type == 'orgtype')
      _source = this.orgtypes;
    else if (type == 'feedbacktype')
      _source = this.feedbacktypes;
    else if (type == 'purpose')
      _source = this.purposes;
    else
      return;
    let _selected = _.filter(_source, {selected: true});
    let _selected2 = _.each(_selected, (source: any) => {
        source.state = 'deleted';
    });
    let names = _.reduce(_selected, (res: string, selected:any) => {
      return res + "<li>" + selected.name + "</li>"
    }, "");
    swal({
      title: "Are you sure want delete these items?",
      text: "<ul>"+names+"</ul>",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      closeOnConfirm: false,
      html: true
    }, (isConfirm: boolean) => {
      if (isConfirm) {
        this.ClassificationService.updateAll(_selected2).$promise.then(() => {
          swal("Deleted!", "Your selected items has been deleted", "success");
          this.loadClassification();
        })
        .catch(() => {
          swal("Sorry!", "Your items are failed to delete, please try again!", "error");
        });
      }
    })
  }
}
